import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Css, Responsive } from '../../../../../../ui';
import {
	BaseCell,
	BaseHeader,
} from '../../../../../flights/overview/ui/list/columns/Column';
import {
	proposerListValueStylesMobile,
	solicitationListHeaderStyles,
} from '../../../solicitations-list/columns/Column.styles';
import { Color } from '../../../../../../styles/Color';

interface IProposerPhoneProps {
	phone?: string;
}

const styles = css`
	display: flex;
	width: 120px;
	max-width: 120px;
	margin-right: ${Css.pxToRem(40)};
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
	${solicitationListHeaderStyles}
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		justify-content: flex-end;
	}
`;

const Phone = styled.div`
	font-weight: 500;
	font-size: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(19)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		inline-size: min-content;
		width: max-content;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		${proposerListValueStylesMobile}
	}
`;

export function Header() {
	return <StyledHeader css={styles}>Phone</StyledHeader>;
}

export function MobileHeader() {
	return <StyledHeader css={styles}>Phone:</StyledHeader>;
}

export function Cell({ phone }: IProposerPhoneProps) {
	return (
		<StyledCell css={styles}>
			<Phone>{phone || '-'}</Phone>
		</StyledCell>
	);
}
